export default __webpack_public_path__ + "static/media/logo.19edeb4e.png";